export default __webpack_public_path__ + "locales/ro/VersionHistory.json?hash=88a0c9cb4c685f12cc876d175a3a1ae9";